import { styled } from "@mui/material";

export const Layout = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 8em 2em;
  max-width: 680px;
  margin: 0 auto;
  text-align: center;

  * {
    line-height: 1.8 !important;
  }
`;
